import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { UtilsService } from "../../../utils/utils.service";
import { EventsManagementService } from "../../services/events-management.service";
import { LoadingService } from "../../services/loading.service";
import { EventInfoResponseBody } from "../../services/types/events-management-response.type";
import { EventCardComponent } from "../../shared/components/cards/event-card/event-card.component";

@Component({
  selector: "app-event-search",
  imports: [FormsModule, AppLayoutComponent, EventCardComponent],
  templateUrl: "./event-search.component.html",
  styleUrl: "./event-search.component.scss",
})
export class EventSearchComponent implements OnInit {
  searchParams: string = "Shows"; // Exemplo de termo pesquisado
  // Filtros disponíveis
  cities: string[] = [];
  categories: string[] = [];

  // Filtros selecionados
  selectedCity: string = "";
  selectedCategory: string = "";
  isOnline: string = ""; // 'true', 'false', ou '' (para todos)
  hasPassed: string = ""; // 'true', 'false', ou '' (para todos)

  // Resultados filtrados
  filteredEvents: EventInfoResponseBody[] = [];

  searchResults: EventInfoResponseBody[] = [];

  constructor(
    private route: ActivatedRoute,
    private eventsManagementService: EventsManagementService,
    private utilsService: UtilsService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.loadingService.show();

    try {
      this.route.paramMap.subscribe((params) => {
        this.searchParams = String(params.get("searchParams"));
      });

      this.route.queryParamMap.subscribe((params) => {
        if (params.get("category")) {
          console.log("Query Params:", params.get("category"));
          this.handleSearchByCategory(Number(params.get("category")));
        }
      });

      // Inicializar os filtros
      this.cities = [
        ...new Set(this.searchResults.map((event) => event.address?.city_name)),
      ];
      this.categories = [
        ...new Set(
          this.searchResults.map((event) => event.event_category?.title),
        ),
      ];
    } catch (error) {
      console.log("Erro ao carregar pesquisa", error);
    } finally {
      this.loadingService.hide();
    }
  }

  handleSearchByCategory(category_id: number) {
    this.eventsManagementService.getEventsByCategory(category_id).subscribe({
      next: (response) => {
        if (response?.data?.length > 0) {
          this.searchResults = response.data.filter(
            (item) => item.status == "published" && !item.is_private,
          );

          // Exibir todos os eventos inicialmente
          this.filteredEvents = this.searchResults;
        }
      },
      error: (error) => {
        console.error("Erro ao carregar o eventos:", error);
      },
    });
  }

  applyFilters(): void {
    this.filteredEvents = this.searchResults.filter((event) => {
      const matchesCity = this.selectedCity
        ? event.address?.city_name === this.selectedCity
        : true;
      const matchesCategory = this.selectedCategory
        ? event.event_category?.title === this.selectedCategory
        : true;
      const matchesOnline = this.isOnline
        ? this.isOnline === "true"
          ? event.online
          : !event.online
        : true;

      // Verifica se o evento já passou
      const matchesHasPassed =
        this.hasPassed === "true"
          ? this.utilsService.isPast(event.end_date)
          : this.hasPassed === "false"
            ? !this.utilsService.isPast(event.end_date)
            : true;

      return (
        matchesCity && matchesCategory && matchesOnline && matchesHasPassed
      );
    });
  }
}
